import $ from 'jquery';
import { getUser, isLoggedUserGlobalEditor } from '~src/user';
import { isAfter } from 'date-fns';
import { router } from '~src/router/index';

export const checkOrgStatus = async ({ redirect = true } = {}) => {
  const { user } = await getUser();

  const isUserSubscriptionActive =
    user.org_pointer.tipo_istanza === 'production' &&
    user.org_pointer.stato === 'attiva';

  const isGlobalEditor = await isLoggedUserGlobalEditor();

  if (
    user.user_status !== false &&
    (isUserSubscriptionActive || isGlobalEditor)
  ) {
    // all good
    return true;
  }

  const isUserInDemo = user.org_pointer.tipo_istanza === 'demo';

  let demoScaduta = false;
  let userBlocked = false;

  if (
    user.org_pointer.giotto === true &&
    user.org_pointer.data_scadenza_giotto
  ) {
    demoScaduta = isAfter(
      new Date(),
      new Date(user.org_pointer.data_scadenza_giotto.iso)
    );
  }
  if (user.org_pointer.ofc === true && user.org_pointer.data_scadenza) {
    demoScaduta = isAfter(
      new Date(),
      new Date(user.org_pointer.data_scadenza.iso)
    );
  }

  if (user.org_pointer.stato === 'disattiva') {
    demoScaduta = true;
  }

  if (user.org_pointer.stato === 'disattiva' || user.user_status === false) {
    userBlocked = true;
  }

  function showTrialEnded(title = 'La tua demo è scaduta &#129325') {
    const trialEndedHtml = `
      <div class="row mt-5">
        <div class="col pr-5 pl-5 text-center">
          <div class="row howto-help-container p-5">
            <div class="col-12">
              <h1 class="text-dark">${title}</h1>
            </div>
            <div class="col-12">
              <p class="lead text-dark">
                Hai bisogno del nostro aiuto?
              </p>
              <button class="btn btn-lg btn-success open_chat_button">
                Chatta con noi
              </button>
            </div>
            <div class="col-12 mt-3">
              <p class="lead text-dark">
                Acquista un abbonamento per continuare a lavorare 
              </p>
            </div>
          </div>
        </div>
      </div>`;
    $('.trialEnded').html(trialEndedHtml);
    if (redirect) {
      $('.editor-route').hide();
      $('.app-spinner').hide();
      router.navigate('/subscription');
    }
  }

  if (isUserInDemo && demoScaduta) {
    showTrialEnded();
    return false;
  }

  if (userBlocked) {
    showTrialEnded(
      user.user_status === false
        ? 'Il tuo utente è stato disattivato. Contatta l’amministratore della tua azienda.'
        : 'L’accesso della tua azienda è sospeso. Contatta l’assistenza.'
    );
    return false;
  }

  return true;
};
